import React from 'react';
import { faTire } from '@fortawesome/pro-light-svg-icons/faTire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TireLightIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTire} {...props} />;
}
